import { JourneyDataModel } from '../../../../services/redux/features/journeyData.slice';
import { PrivateProspectFormModel } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: PrivateProspectFormModel): Partial<JourneyDataModel> => {
  return {};
};
